import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setSuggestionPillIds } from '../actions/internalActions';

export default mutator(setSuggestionPillIds, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).suggestionPillIds = actionMessage.suggestionPillIds;
});
